import { measureLatency } from '../../gctl-measure';
import { NetworkError, deepCamelCase, deepSnakeCase } from '../../fetchers/_helpers';

/**
 * This file was automatically generated by @gctl/openapi-fetchers
 * Do not modify this file, any changes will be destroyed when
 * the command is rerun.
 */

export type PostVideoReportFields = readonly string[];

/** Options for POST /videos/{video_id}/report */
export type PostVideoReportOptions<Paths extends readonly string[]> = Omit<
  RequestInit,
  'method' | 'body'
> & {
  baseUrl?: string;

  where: {
    /**
     * The ID of the video.
     */
    videoId: number;
  };

  /** Data serialized to body for POST /videos/{video_id}/report */
  variables: {
    /**
     * Additional information on the reason for the flag.
     * @example This video should be rated mature
     */

    comment?: string;

    /**
     * The reason for the report.
     *
     * Option descriptions:
     *  * `advertisement` - The video is an advertisement.
     *  * `csam` - The video contains Child Sexual Abuse Material.
     *  * `extremist` - The video contains extremist content.
     *  * `harassment` - The video constitutes harassment.
     *  * `hate speech` - The video contains hate speech.
     *  * `high_bandwidth` - The video requires high bandwidth.
     *  * `incorrect rating` - The video doesn't have the proper rating.
     *  * `pornographic` - The video is pornographic.
     *  * `ripoff` - The video supports a scam.
     *  * `spam` - The video is spam.
     *  * `voting misinformation` - The video contains misinformation about voting, elections, or election results.
     *
     */

    reason:
      | `advertisement`
      | `csam`
      | `extremist`
      | `harassment`
      | `hate speech`
      | `high_bandwidth`
      | `incorrect rating`
      | `pornographic`
      | `ripoff`
      | `spam`
      | `voting misinformation`;
  };
};

/** Result type for POST /videos/{video_id}/report */
export type PostVideoReportResult<Paths extends readonly string[]> = unknown;

/**
 * Flag a video
 * This method flags the specified video.
 */
export async function postVideoReport<Paths extends PostVideoReportFields>({
  baseUrl,
  variables,
  where: { videoId },
  ...options
}: PostVideoReportOptions<Paths>): Promise<PostVideoReportResult<Paths>> {
  return measureLatency('postVideoReport', 'POST', async () => {
    let res = await fetch(`${baseUrl}/videos/${videoId}/report`, {
      ...options,
      method: 'POST',
      body: JSON.stringify(deepSnakeCase(variables)),
    });

    if (!res.ok) {
      throw new NetworkError('A network error occurred', res.status, res);
    }

    if (res.status === 204) {
      return null as unknown as PostVideoReportResult<Paths>;
    }

    if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
      throw new Error('Expected JSON response');
    }

    let json = await res.json();
    return deepCamelCase(json);
  });
}
